import React, { ReactHTML, useEffect, useRef, useState } from "react";
import ButtonV2 from "../../shared/components/buttonV2";

import {
  CHEVRON_LEFT,
  CLOSE,
  EMPTY_SEARCH_2,
  PROFILE_ADD,
  SEARCH_INPUT_ICON,
} from "../../assets";
import PageTitle from "../../shared/components/pagetitle";
import TableComponent from "../../shared/components/table";
import { useQuery } from "react-query";
import {
  deleteCase,
  getAllCases,
  uploadAdminCsv,
} from "../../Services/admin.service";
import { CASE_COLUMN } from "../../shared/components/table/columns";
import { SearchHistoryTypes } from "../../types";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  openCaseModal,
  selectCase,
  selectCaseFormModal,
  selectEditMode,
  setCaseDetailModal,
  setCaseFormModal,
  setDeleteModal,
  setEditMode,
  setSelectedCaseDetails,
  showDeleteModal,
} from "../../states/slices/globalReducer";
import CaseDetailsModal from "../../shared/components/casedetailsmodal";
import ModalV2 from "../../shared/components/modalV2";
import CaseFormModal, {
  FormFieldProps,
} from "../../shared/components/caseformModal";
import SuccessModal from "../../shared/components/successModal";
import DeleteModal from "../../shared/components/deleteModal";
import { toast } from "react-hot-toast";
import { Loader2 } from "lucide-react";
import * as XLSX from "xlsx";

function ManageCases() {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentpage, setCurrentpage] = useState(1);
  const dispatch = useAppDispatch();
  const [uploadCaseModal, setUploadCaseModal] = useState(false);
  // const [caseFormModal, setCaseFormModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [uploadingFile, setUploadingFile] = useState(false);
  const caseFormModal = useAppSelector(selectCaseFormModal);
  const caseDetailModal = useAppSelector(openCaseModal);

  const {
    data: allCases,
    refetch,
    isLoading,
  } = useQuery(["cases", currentpage], () => getAllCases(currentpage));

  const filterCases = allCases?.data?.filter((item: SearchHistoryTypes) =>
    item.title?.toLowerCase().includes(searchQuery.toLowerCase()),
  );
  const editMode = useAppSelector(selectEditMode);
  const [deleting, setDeleting] = useState(false);
  const caseDetails = useAppSelector(selectCase);

  const [success, setSuccess] = useState(false);
  const pagesRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const deleteModal = useAppSelector(showDeleteModal);
  const [error, setError] = useState<any>([]);
  const [progress, setProgress] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const uploadRef = useRef<HTMLInputElement | null>(null);
  const [formField, setFormField] = useState<FormFieldProps>({
    title: "",
    title_number: "",
    survey_plan_number: "",
    owner_name: "",
    address: "",
    parties: "",
    subject_matter: "",
    suit_number: "",
    court_details: "",
    date_of_commencement: "",
    date_of_disposal: "",
    name_of_parties: "",
    nature_of_case: "",
    reliefs_sought: "",
    judicial_division: "",
    description_of_properties: "",
  });
  useEffect(() => {
    const selectedButton = pagesRefs.current[currentpage];
    if (selectedButton) {
      selectedButton.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentpage]);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const response = await deleteCase(caseDetails?.id);
      if (response) {
        toast.success(response?.message);
        dispatch(setDeleteModal(false));
        refetch();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setDeleting(false);
    }
  };

  // const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target?.files && e.target.files[0];
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     const bstr = event.target?.result;
  //     const workSheet = XLSX.read(bstr, { type: "binary" });
  //     const workSheetName = workSheet.SheetNames[0];
  //     const sheet = workSheet.Sheets[workSheetName];

  //     const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

  //     const headers = data[0];
  //     const values = data[1];

  //     const filledData = {};
  //     // @ts-ignore
  //     headers.forEach((header, index) => {
  //       // @ts-ignore
  //       filledData[header.toLowerCase()] = values[index];
  //     });

  //     setFormField((prev) => ({ ...prev, ...filledData }));
  //   };

  //   // @ts-ignore
  //   reader.readAsBinaryString(file);
  //   setUploadCaseModal(false);
  //   dispatch(setCaseFormModal(true));
  // };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];

    if (!file) return;
    setUploadedFile(file);
    setUploadingFile(true);
    // Papa.parse(file, {
    //   header: true,
    //   skipEmptyLines: true,
    //   complete(results, file) {
    //     setRows(results?.data);
    //   },
    // });

    try {
      const formData = new FormData();

      formData.append("csv_file", file);

      const response = await uploadAdminCsv(formData, setProgress);
      if (response) {
        toast.success(response?.message);
        setUploadCaseModal(false);
        refetch();
        setUploadedFile(null);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      setError(error?.response?.data?.data);
    } finally {
      setUploadingFile(false);
    }
  };

  const handleDownloadDoc = (url: string) => {
    const fileName = url.split(".")[1];
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();
  };

  useEffect(() => {
    if (selectedRow !== null) setUploadCaseModal(false);
  }, [selectedRow]);
  return (
    <div className="p-3 sm:p-5 w-full max-w-full overflow-hidden">
      <div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <div className="flex-1 min-w-0">
          <PageTitle
            title="Manage Properties"
            subtitle="Track all your cases"
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <ButtonV2
            title={"Upload New Case"}
            image={PROFILE_ADD}
            btnStyle={
              "flex items-center justify-center gap-x-1 bg-globalGold px-3 py-2 rounded-xl flex-row-reverse w-full sm:w-auto"
            }
            textStyle={"text-[#FAFAFA] font-medium text-sm"}
            handleClick={() => {
              dispatch(setEditMode(false));
              setUploadCaseModal(true);
              setSelectedCaseDetails(null);
            }}
          />
        </div>
      </div>

      <div className="w-full mt-8 border border-borderColor py-4 rounded-xl overflow-hidden">
        <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center px-4 gap-3 sm:gap-4">
          <span className="text-[#2A2E34] font-semibold text-sm sm:text-[16px] flex-shrink-0">
            Cases
          </span>
          <div className="w-full sm:w-fit min-w-0 sm:min-w-[250px] items-center gap-x-2 flex px-3 py-2 rounded-xl border border-borderColor">
            <img
              src={SEARCH_INPUT_ICON}
              className="w-[16px] h-[16px] sm:w-[20px] sm:h-[20px] flex-shrink-0"
              alt=""
            />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full min-w-0 bg-transparent placeholder:text-sm outline-none"
              placeholder="Search cases"
            />
          </div>
        </div>

        {allCases?.data?.length > 0 ? (
          <div className="mt-2">
            <div className="overflow-x-auto">
              <TableComponent
                DATA={filterCases}
                //@ts-ignore
                COLUMNS={CASE_COLUMN}
              />
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between pt-3 px-3 sm:px-5 gap-3">
              <div className="flex items-center gap-2 order-2 sm:order-1">
                <button
                  type="button"
                  onClick={() =>
                    setCurrentpage(allCases?.meta?.current_page - 1)
                  }
                  disabled={allCases?.meta?.current_page === 1}
                  className={`border border-[#EBEBEB] rounded-xl w-[35px] h-[35px] sm:w-[40px] sm:h-[40px] flex items-center gap-x-2 justify-center ${
                    allCases?.meta?.current_page === 1 &&
                    "opacity-50 cursor-not-allowed"
                  }`}
                >
                  <img
                    src={CHEVRON_LEFT}
                    className="w-[16px] h-[16px] sm:w-[20px] sm:h-[20px]"
                    alt=""
                  />
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setCurrentpage(allCases?.meta?.current_page + 1)
                  }
                  disabled={
                    allCases?.meta?.current_page === allCases?.meta?.last_page
                  }
                  className={`border border-[#EBEBEB] rounded-xl w-[35px] h-[35px] sm:w-[40px] sm:h-[40px] flex items-center gap-x-2 justify-center ${
                    allCases?.meta?.current_page ===
                      allCases?.meta?.last_page &&
                    "opacity-50 cursor-not-allowed"
                  }`}
                >
                  <img
                    src={CHEVRON_LEFT}
                    className="w-[16px] h-[16px] sm:w-[20px] sm:h-[20px] scale-x-[-1]"
                    alt=""
                  />
                </button>
              </div>
              <div
                className={`flex items-center gap-x-1 sm:gap-x-2 order-1 sm:order-2 ${
                  allCases?.meta?.links?.slice(1, -1).length > 5 &&
                  "max-w-[250px] sm:max-w-[300px] overflow-x-auto"
                }`}
              >
                {allCases?.meta?.links
                  ?.slice(1, -1)
                  .map((page: any, index: number) => (
                    <button
                      key={index}
                      ref={(el) => (pagesRefs.current[index] = el)}
                      onClick={() => {
                        page.url && setCurrentpage(Number(page.label));
                      }}
                      className={`flex items-center justify-center pt-[0.5px] hover:bg-globalGold hover:text-white transition-all duration-300 gap-x-3 min-w-[32px] h-[32px] sm:min-w-[40px] sm:h-[40px] rounded-xl flex-shrink-0 ${
                        page.active
                          ? "bg-globalGold text-white"
                          : "border text-[#2A2E34]"
                      } `}
                    >
                      <span className={`text-xs sm:text-[13px]`}>
                        {page.label}
                      </span>
                    </button>
                  ))}
              </div>
            </div>
          </div>
        ) : isLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 color="#9ca3af" size={30} className="animate-spin" />
          </div>
        ) : (
          <div className="flex flex-col gap-y-2 pb-5 justify-center items-center w-full px-4">
            <img
              src={EMPTY_SEARCH_2}
              className="w-[120px] h-[100px] sm:w-[147.69px] sm:h-[120px]"
              alt=""
            />
            <span className="text-lg sm:text-xl font-bold text-customDark text-center">
              No Cases Yet
            </span>
            <span className="text-sm font-medium text-primary-50 max-w-sm sm:max-w-96 text-center px-4">
              You haven't Added any case yet. Click the button below to begin
              your first Case upload.
            </span>
            <button
              onClick={() => setUploadCaseModal(true)}
              className="w-fit hover:scale-95 transition-all duration-300 bg-globalGold px-4 sm:px-5 py-2 rounded-3xl flex items-center justify-center gap-x-2 mt-2"
            >
              <img
                src={PROFILE_ADD}
                className="w-[16px] h-[16px] sm:w-[20px] sm:h-[20px]"
                alt=""
              />
              <span className="text-sm sm:text-[16px] font-medium text-white">
                Add New Case
              </span>
            </button>
          </div>
        )}
      </div>
      <CaseDetailsModal
        open={caseDetailModal}
        close={() => {
          dispatch(setCaseDetailModal(false));
          dispatch(setSelectedCaseDetails(null));
        }}
        caseDetails={caseDetails}
      />
      <CaseFormModal
        existingCaseDetails={caseDetails}
        open={caseFormModal || selectedRow !== null || false}
        setFormField={setFormField}
        formField={formField}
        onSuccess={() => setSuccess(true)}
        close={() => {
          dispatch(setCaseFormModal(false));

          dispatch(setSelectedCaseDetails(null));
        }}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
      />

      <ModalV2
        isOpen={uploadCaseModal}
        isClose={() => {
          setUploadCaseModal(false);
          dispatch(setSelectedCaseDetails(null));
          setError([]);
        }}
        edges="rounded-xl"
        maxWidth="w-full max-w-[800px] mx-4"
      >
        <div className="flex items-center w-full p-3 justify-between border-b border-borderColor">
          <span className="text-[#2A2E34] font-semibold text-base sm:text-lg flex-1">
            Upload Case
          </span>
          <button
            onClick={() => {
              setUploadCaseModal(false);
              setError([]);
              setUploadedFile(null);
            }}
            className="hover:bg-[#F2F2F2] w-[35px] h-[35px] rounded-full flex items-center justify-center flex-shrink-0"
            type="button"
          >
            <img
              src={CLOSE}
              className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]"
              alt="times"
            />
          </button>
        </div>
        {uploadedFile && error?.length === 0 ? (
          uploadingFile && (
            <div className="mt-4 p-3 sm:p-5">
              <div className="text-sm text-gray-700 font-medium break-all">
                {uploadedFile.name}
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                <div
                  className="bg-globalGold h-2.5 rounded-full transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
              {progress === 100 && (
                <p className="text-green-600 flex text-center justify-center text-sm mt-1">
                  Upload complete
                </p>
              )}
            </div>
          )
        ) : error?.length > 0 ? (
          <div className="p-3 sm:p-5">
            <div className="max-h-64 overflow-y-auto mt-4 border rounded-md border-red-200">
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left">
                  <thead className="bg-red-50 text-red-700 font-medium border-b border-red-200">
                    <tr>
                      <th className="px-2 sm:px-4 py-2">Row</th>
                      <th className="px-2 sm:px-4 py-2">Status</th>
                      <th className="px-2 sm:px-4 py-2">Errors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {error.map((rowError: any, index: number) => (
                      <tr key={index} className="border-b last:border-none">
                        <td className="px-2 sm:px-4 py-2 font-medium text-gray-700">
                          Row {rowError.row}
                        </td>
                        <td className="px-2 sm:px-4 py-2 capitalize text-red-600">
                          {rowError.status}
                        </td>
                        <td className="px-2 sm:px-4 py-2">
                          <ul className="list-disc list-inside text-gray-700 space-y-1">
                            {rowError.errors.map((err: any, idx: number) => (
                              <li key={idx} className="break-words">
                                {err}
                              </li>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-y-3 justify-center items-center w-full p-8 sm:p-20">
            <ButtonV2
              title={"Upload Case Manually"}
              btnStyle={
                "w-full sm:w-[230px] px-4 py-2 bg-globalGold rounded-xl"
              }
              textStyle={"text-sm font-medium text-white"}
              handleClick={() => {
                setUploadCaseModal(false);
                dispatch(setCaseFormModal(true));
                dispatch(setSelectedCaseDetails(null));
              }}
            />
            <ButtonV2
              title={"Upload by CSV"}
              btnStyle={
                "w-full sm:w-[230px] px-4 border border-borderColor rounded-xl py-2 flex items-center justify-center"
              }
              textStyle={"text-sm font-medium text-customDark"}
              handleClick={() => uploadRef?.current?.click()}
            />
            <input
              type="file"
              ref={uploadRef}
              accept=".csv, .xlsx"
              onChange={handleFileUpload}
              className="sr-only"
            />
            <ButtonV2
              title={"Download CSV Template"}
              btnStyle={
                "w-full sm:w-[230px] px-4 border border-borderColor rounded-xl py-2 flex items-center justify-center"
              }
              textStyle={"text-sm font-medium text-customDark"}
              handleClick={() =>
                handleDownloadDoc("/Lispendes-csv-template.csv")
              }
            />
          </div>
        )}
      </ModalV2>

      <SuccessModal
        open={success}
        close={() => setSuccess(false)}
        action={() => {
          refetch();
          setSuccess(false);
          dispatch(setEditMode(false));
        }}
        message={`Case Successfully ${editMode ? "Updated" : "Added"}`}
        message2={`You have successfully  ${
          editMode ? "updated" : "added"
        } a case`}
      />
      <DeleteModal
        open={deleteModal}
        close={() => dispatch(setDeleteModal(false))}
        deleteTitle={"Case Folder"}
        warningMessage={`the case “${caseDetails?.title}”`}
        lastmessage={"cases"}
        handleDelete={handleDelete}
        loading={deleting}
      />
    </div>
  );
}

export default ManageCases;
